import { render, staticRenderFns } from "./category.vue?vue&type=template&id=753618f3&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753618f3')) {
      api.createRecord('753618f3', component.options)
    } else {
      api.reload('753618f3', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=753618f3&", function () {
      api.rerender('753618f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/category.vue"
export default component.exports